var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpandTypesIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7 6H4.5v2.5H7V7h4v4H9.5v2.5H12V12h4v4h-4v-1.5H8.5V11H7V9.5H3.5V6H1V0h6zm6 9h2v-2h-2zm-5-5h2V8H8zM2 5h4V1H2z",
  clipRule: "evenodd"
})));
export default SvgExpandTypesIcon;